import React from 'react';

interface IMinusIconProps {
  style?: any;
  onClick?: () => void;
}

export const MinusIcon:React.FC<IMinusIconProps> = (props: IMinusIconProps) => {
  return (
    <svg onClick={props.onClick} width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" style={props.style}>
      <circle cx="8" cy="8" r="7.5" stroke="#8891A0"/>
      <line x1="4" y1="8" x2="12" y2="8" stroke="#8891A0" strokeWidth="2"/>
    </svg>
  )
}